// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice[data-v-6e623352] {\n  background: #ffffe8;\n  padding: 11px 20px;\n  margin-bottom: 10px;\n  color: #222;\n}\n.notice .iconfont-npm.icon-npm-a-lujing244[data-v-6e623352] {\n    color: #ff7300;\n    margin-right: 5px;\n    font-size: 12px !important;\n}\n.notice a[data-v-6e623352] {\n    color: #389eff;\n}\n", ""]);
// Exports
module.exports = exports;
